import { GET_SUPPORT_TOTAL_UNREAD_COUNT,SELECTED_SUPPORT_CHAT } from "../../constants/support/support";




const initialState = {
    supportTotalUnreadCountData: 0,
}


export const GetSupportDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SUPPORT_TOTAL_UNREAD_COUNT:
            return {
               ...state,
                supportTotalUnreadCountData: action.payload.totalUnreadCount,
            }
        default:
            return state;
    }
}

const initial ={
    selectedSupportChatId: null,
}

export const GetSelectedSupportChatReducer = (state = initial, action) => {
    switch (action.type) {
        case SELECTED_SUPPORT_CHAT:
            return {
               ...state,
                selectedSupportChatId: action.payload,
            }
        default:
            return state;
    }
}